export default {
  ADDRESS: {
    FIRST_NAME: ["ชื่อ", "First Name"],
    LAST_NAME: ["นามสกุล", "Last Name"],
    EMAIL: ["อีเมลล์", "Email"],
    STREET_ADDRESS: ["ที่อยู่", "Street Address"],
    PROVINCE: ["จังหวัด", "Province"],
    DISTRICT: ["เขต / อำเภอ", "District"],
    SUBDISTRICT: ["แขวง / ตำบล", "Subdistrict"],
    ZIPCODE: ["รหัสไปรษณีย์", "Zipcode"],
    COUNTRY_CODE: ["รหัสประเทศ", "Country Code"],
    DELIVERY_ADDRESS: ["ที่อยู่จัดส่ง", "Delivery Address"],
    NO_ADDRESS_SELECTED: ["ยังไม่ได้เลือกที่อยู่ หรือ สามารถเพิ่มที่อยู่ใหม่โดยกดปุ่มด้านล่างนี้ค่ะ", "No address selected or you can add new address by clicking the button below"],
    ADD_NEW_ADDRESS: ["เพิ่มที่อยู่ใหม่", "Add New Address"],
    TAX_ADDRESS: ["ข้อมูลสำหรับออกใบกำกับภาษี", "Tax Address"],
    TAX_ID: ["หมายเลขประจำตัวผู้เสียภาษี", "Tax ID"],
    SAVE_ADDRESS: ["บันทึกที่อยู่ไว้ใช้ครั้งหน้า", "Save Address"],
    MOBILE: ["เบอร์โทรศัพท์", "Mobile"],
    MOBILE_2: ["เบอร์โทรศัพท์ 2", "Mobile 2"],
  }
}